import {Navbar, NavDropdown, Offcanvas, Container, Nav} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {Donate} from "../donate/donate";
import {contentLoader} from "../loader/loader";

export const Navigation = () => {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();


    // Set language prefix and content based on the selected language
    const content =  contentLoader();
    let languagePrefix = i18n.language === 'nl' ? '/nl' : '';
    let _content_translation =content.filter((c)=>{
       return c.locale === i18n.language && c.menu !== null
    })

    // Generate menu links based on the content file for the current language
    let Links = _content_translation.filter(c => c.menu).map((c, index) => (
        <Nav.Item key={index}>
            <Nav.Link href={`${languagePrefix}${c?.slug}`}>{c.menu}</Nav.Link>
        </Nav.Item>
    ));

    // Handle language change and navigation
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        navigate(lang === 'nl' ? '/nl' : '/');
    };

    return (
        <Navbar expand={'sm'} sticky={'top'} className="bg-body-tertiary">
            <Container>
                <Navbar.Brand>
                    <div className="d-flex align-items-center">
                        <img onClick={() => navigate('/')} width={30} src="/images/icons/pysport_icon_darkblue.svg" alt="PySport"/>

                    </div>
                </Navbar.Brand>


                {/* Language dropdown for language selection */}
                <NavDropdown title={i18n.language.toUpperCase()} id="language-dropdown" className={'me-md-3 me-auto'}>
                    <NavDropdown.Item className={i18n.language === 'en'?'active': ''} onClick={() => changeLanguage('en')}>EN</NavDropdown.Item>
                    <NavDropdown.Item className={i18n.language === 'nl'?'active': ''} onClick={() => changeLanguage('nl')}>NL</NavDropdown.Item>
                </NavDropdown>

                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Offcanvas collapseOnSelect className="justify-content-end" placement="end"
                                  id="basic-navbar-nav">
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title id="offcanvasNavbarLabel-expand">
                            Pysport
                        </Offcanvas.Title>

                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div className="py-4 d-sm-none">
                            <Donate/>
                        </div>
                        <Nav className="me-auto">
                            <Nav.Link href={`${languagePrefix}/`}>Home</Nav.Link>
                            {Links}
                            <Nav.Link href="/analytics-cup" className="nav-link--cup text-nowrap">
                                Analytics Cup
                            </Nav.Link>
                        </Nav>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>
                <div className="ml-auto d-none d-md-block">
                    <Donate/>
                </div>

            </Container>

        </Navbar>
    );
}
